
<template>
  <div>
    <div class="find">
      <div class="seach-top">
        <el-form ref="searchForm" :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item>
            <el-input v-model="searchForm.keyWord1" placeholder="手机号/邮箱" size="small" clearable />
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchForm.keyWord2" placeholder="姓名/别名" size="small" clearable />
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchForm.keyWord3" placeholder="单位/部门/科室/职务" size="small" clearable />
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchForm.keyWord4" placeholder="其他" size="small" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="handleSearch">
              查询
            </el-button>
          </el-form-item>
          <div class="btn-box" style="float: right;">
            <el-form-item>
              <el-button v-if="ketiInfo.isFuzeren || ketiInfo.isZuli" type="primary" size="small" @click="handleAdd2">
                新增
                <i class="el-icon-plus el-icon--right" />
              </el-button>
            </el-form-item>
            <el-form-item>
              <upload-excel-component style="display:inline;" :on-success="handleImportSuccess" :before-upload="handleBeforeUpload" />
            </el-form-item>
            <el-form-item>
              <el-button style="margin-left: 8px" size="small" type="primary" @click="handleExport()">
                导出
                <i class="el-icon-download el-icon--right" />
              </el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>

    <el-table v-if="false" class="table-list" :border="true" :data="tableData" style="width: 100%" @sort-change="handleResort">
      <!-- 参与身份 -->
      <el-table-column prop="userRoleDictItemName" label="参与身份" width="150" sortable="custom" align="center">
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.userRoleDictItemName }}</span>
          </div>
        </template>
      </el-table-column>
      <!-- 姓名 -->
      <el-table-column prop="userName" label="姓名" width="150" sortable="custom" align="center">
        <template slot-scope="scope">
          <div>
            <el-button v-if="!scope.row.isEdit" type="text" size="small" @click.native.prevent="handleToDtl(scope.row.id)">
              {{ scope.row.userName }}
            </el-button>
            <el-input v-if="scope.row.isEdit" v-model="scope.row.userName" prop="userName" size="small" placeholder="请输入姓名" />
          </div>
        </template>
      </el-table-column>

      <!-- 手机号码 -->
      <el-table-column prop="phoneNumber" label="手机号码" width="150" sortable="custom" align="center">
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.phoneNumber }}</span>
            <el-input v-if="scope.row.isEdit" v-model="scope.row.phoneNumber" prop="phoneNumber" size="small" placeholder="请输入手机号码" />
          </div>
        </template>
      </el-table-column>

      <!-- 电子邮箱 -->
      <el-table-column prop="emailAddress" label="电子邮箱" width="150" sortable="custom" align="center">
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.emailAddress }}</span>
            <el-input v-if="scope.row.isEdit" v-model="scope.row.emailAddress" prop="emailAddress" size="small" placeholder="请输入电子邮箱" />
          </div>
        </template>
      </el-table-column>

      <!-- 性别 -->
      <el-table-column prop="sexDictItemName" label="性别" width="150" sortable="custom" align="center">
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.sexDictItemName }}</span>
          </div>
        </template>
      </el-table-column>

      <!-- 单位名称 -->
      <el-table-column prop="danWeiMingCheng" label="单位名称" width="150" sortable="custom" align="center">
        <template slot-scope="scope">
          <div>
            <span v-if="scope.row.userIdentityKey>0">{{ scope.row.userIdentityDanWeiMingCheng }}</span>
            <span v-else>{{ scope.row.danWeiMingCheng }}</span>
          </div>
        </template>
      </el-table-column>

      <!-- 部门/科研团队 -->
      <el-table-column prop="danWeiBuMenFullName" label="部门/科研团队" width="150" sortable="custom" align="center">
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.danWeiBuMenFullName }}</span>
          </div>
        </template>
      </el-table-column>

      <!-- 课题组 -->
      <el-table-column prop="userIdentityKetizuMingcheng" label="课题组" width="150" sortable="custom" align="center">
        <template slot-scope="scope">
          <div>
            <span v-if="scope.row.userIdentityKey>0">{{ scope.row.userIdentityKetizuMingcheng }}</span>
          </div>
        </template>
      </el-table-column>

      <!-- 学位 -->
      <el-table-column prop="keShi" label="学位1" width="150" sortable="custom" align="center">
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.zuiGaoXueWeiDictItemName }}</span>
          </div>
        </template>
      </el-table-column>

      <!-- 研究领域 -->
      <el-table-column prop="yanJiuLingYu" label="研究领域" width="150" sortable="custom" align="center">
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.yanJiuLingYu }}</span>
          </div>
        </template>
      </el-table-column>

      <!-- 研究方向 -->
      <el-table-column prop="yanJiuFangXiang" label="研究方向" width="150" sortable="custom" align="center">
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.yanJiuFangXiang }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="200" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.memberListEditFlag">
            <el-button v-if="!scope.row.isEdit" type="text" size="mini" plain @click.stop="handleEdit( scope.row,scope.$index)">
              修改
            </el-button>
            <el-button v-if="scope.row.isEdit" type="text" size="small" @click.stop="handleSave(scope.row)">
              保存
            </el-button>
            <el-button v-if="scope.row.isEdit" type="text" size="small" @click.stop="handleCancel(scope.row ,scope.$index)">
              取消
            </el-button>
          </span>
          <span v-if="scope.row.memberListDelFlag" style="margin-left:5px">
            <el-button v-if="!scope.row.isEdit" type="text" size="mini" @click.stop="handleDel(scope.row)">
              删除
            </el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="table-list" :border="true" :data="tableData2" style="width: 100%" @sort-change="handleResort">
      <!-- 参与身份 -->
      <el-table-column prop="userRoleDictName" label="参与身份" width="110" sortable="custom">
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.userRoleDictName }}</span>
          </div>
        </template>
      </el-table-column>
      <!-- 姓名 -->
      <el-table-column prop="userName" label="姓名" width="110" sortable="custom">
        <template slot-scope="scope">
          <div>
            <el-button v-if="!scope.row.isEdit" type="text" size="small" @click.native.prevent="handleViewResume(scope.row)">
              {{ scope.row.userName }}
            </el-button>
            <el-input v-if="scope.row.isEdit" v-model="scope.row.userName" prop="userName" size="small" placeholder="请输入姓名" />
          </div>
        </template>
      </el-table-column>

      <!-- 手机号码 -->
      <el-table-column prop="phoneNumber" label="手机号码" width="120" sortable="custom">
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.phoneNumber }}</span>
            <el-input v-if="scope.row.isEdit" v-model="scope.row.phoneNumber" prop="phoneNumber" size="small" placeholder="请输入手机号码" />
          </div>
        </template>
      </el-table-column>

      <!-- 电子邮箱 -->
      <el-table-column prop="emailAddress" label="电子邮箱" width="150" sortable="custom" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.emailAddress }}</span>
            <el-input v-if="scope.row.isEdit" v-model="scope.row.emailAddress" prop="emailAddress" size="small" placeholder="请输入电子邮箱" />
          </div>
        </template>
      </el-table-column>

      <!-- 性别 -->
      <el-table-column prop="sexDictName" label="性别" width="80" sortable="custom" align="center">
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.sexDictName }}</span>
          </div>
        </template>
      </el-table-column>

      <!-- 单位名称 -->
      <el-table-column prop="danWeiMingCheng" label="单位名称" width="150" sortable="custom" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div>
            <span v-if="scope.row.userIdentityKey>0">{{ scope.row.userIdentityDanWeiMingCheng }}</span>
            <span v-else>{{ scope.row.danWeiMingCheng }}</span>
          </div>
        </template>
      </el-table-column>

      <!-- 部门/科研团队 -->
      <el-table-column prop="danWeiBuMenFullName" label="部门/科室" width="150" sortable="custom" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.buMen }}/{{ scope.row.keShi }}</span>
          </div>
        </template>
      </el-table-column>

      <!-- 课题组 -->
      <el-table-column prop="userIdentityKetizuMingcheng" label="课题组" width="150" sortable="custom" align="center">
        <template slot-scope="scope">
          <div>
            <span v-if="scope.row.userIdentityKey>0">{{ scope.row.userIdentityKetizuMingcheng }}</span>
          </div>
        </template>
      </el-table-column>

      <!-- 学位 -->
      <el-table-column prop="xueWeiDictName" label="学位" width="120" sortable="custom" align="center">
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.xueWeiDictName }}</span>
          </div>
        </template>
      </el-table-column>

      <!-- 研究领域 -->
      <el-table-column prop="yanJiuLingYu" label="研究领域" min-width="120" sortable="custom" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.yanJiuLingYu }}</span>
          </div>
        </template>
      </el-table-column>

      <!-- 研究方向 -->
      <el-table-column prop="yanJiuFangXiang" label="研究方向" min-width="120" sortable="custom" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.yanJiuFangXiang }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="100" align="center">
        <template slot-scope="scope">
          <span v-if="ketiInfo.isFuzeren || ketiInfo.isZuli">
            <el-button v-if="!scope.row.isEdit" type="text" size="mini" plain @click.stop="handleEdit( scope.row,scope.$index)">
              修改
            </el-button>
            <el-button v-if="scope.row.isEdit" type="text" size="small" @click.stop="handleSave(scope.row)">
              保存
            </el-button>
            <el-button v-if="scope.row.isEdit" type="text" size="small" @click.stop="handleCancel(scope.row ,scope.$index)">
              取消
            </el-button>
          </span>
          <span v-if="ketiInfo.isFuzeren || ketiInfo.isZuli" style="margin-left:5px">
            <el-button type="text" size="mini" @click.stop="handleDel2(scope.row)">
              删除
            </el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination background layout="prev, pager, next,total,sizes" :page-sizes="[10, 20, 50, 100]" :page-size="10" :total="totalCount" @size-change="handleSizeChange" @current-change="handleChangePage" />
    <!-- 简历展示 -->
    <Resume
      v-model="resumeShow"
      :resume-user-id="resumeUserId"
      :resume-key="resumeKey"
    />
    <MemberListUpload v-model="uploadFormShow" :upload-data="uploadData" @save-success="handleSearch" />
    <MemberAdd v-model="memberAddShow" :module-code="moduleCode" :module-key="moduleKey" @save-success="handleSearch" />
  </div>
</template>

<script>
import pathReq from '@/api/pathlist'
import MemberListUpload from './MemberListUpload'
import UploadExcelComponent from '@/components/UploadExcel/index.vue'
import KxjCom from '@/utils/kxjcom'
import MemberAdd from './MemberAdd'
import Resume from '@/components/Resume'
export default {
  name: 'UploadExcel',
  components: {
    MemberListUpload,
    UploadExcelComponent,
    MemberAdd,
    Resume
  },
  filters: {
    dateFmt(val) {
      return KxjCom.tableDateFormat(val)
    },
    decFmt(val) {
      return KxjCom.tableDecFormat(val)
    }
  },
  data() {
    return {
      tableHeader: [],
      totalCount: 0,
      tableData: [],
      tableData2: [],
      allComboxData: [],
      searchForm: {
        keyWord1: '',
        keyWord2: '',
        keyWord3: '',
        keyWord4: '',
        pageNumber: 1,
        pageSize: 10,
        sortKey: '',
        sortOrder: '',
        moduleKey: null,
        moduleCode: ''
      },
      uploadData: [],
      uploadFormShow: false,
      moduleKey: null,
      moduleCode: '',
      memberAddShow: false,
      // 简历数据
      resumeShow: false,
      resumeUserId: null,
      resumeKey: null,
      // 课题额外信息(权限)
      ketiInfo: {}
    }
  },

  // 初期化数据
  created() {
    this.$bus.off('MemberListInit')
    this.$bus.on('MemberListInit', this.init)

    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D04;D07').then(res => {
      this.allComboxData = res.data.result
    })
  },
  mounted() { },
  activated() {
  },
  methods: {
    init() {
      this.moduleKey = this.$route.params.id
      this.moduleCode = this.$route.params.moduleCode

      this.handleSearch()
    },
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    // 每页
    handleSizeChange(val) {
      this.searchForm.pageSize = val
      this.handleSearch()
    },
    // 切页
    handleChangePage(page) {
      this.searchForm.pageNumber = page
      this.handleSearch()
    },
    // 排序
    handleResort(column) {
      this.searchForm.sortKey = column.prop
      this.searchForm.sortOrder = column.order
      this.handleSearch()
    },
    // 新增
    handleAdd() {
      const dataNew = {
        id: null,
        isEdit: true,
        canBeEdit: true,
        memberListEditFlag: true,
        memberListDelFlag: true
      }
      this.tableData.unshift(dataNew)
    },
    /** 新增2 */
    handleAdd2() {
      this.memberAddShow = true
    },
    // 查询
    handleSearch() {
      const that = this
      that.searchForm.moduleCode = that.moduleCode
      that.searchForm.moduleKey = that.moduleKey
      const loading = this.$loading(KxjCom.loadOptions)
      // const path = '/api/services/app/TeamMemberApply/GetPagedListTeamMemberApplys'
      // pathReq
      //   .getList(path, that.searchForm)
      //   .then(res => {
      //     loading.close()
      //     that.totalCount = res.data.result.totalCount
      //     that.tableData = res.data.result.items
      //   })

      const path2 = '/api/services/app/WorkEventMemberNewService/GetPagedListTeamMemberNew'
      pathReq
        .getList(path2, that.searchForm)
        .then(res => {
          loading.close()
          that.totalCount = res.data.result.totalCount
          that.tableData2 = res.data.result.items
        }).then(_ => {
          pathReq.getKetiInfo(that.moduleCode, that.moduleKey).then(r => {
            this.ketiInfo = r.data.result
          })
        })
    },
    // 编辑
    handleEdit(row) {
      for (var i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].isEdit) {
          if (this.tableData[i].id) {
            this.tableData[i].isEdit = false
          } else {
            this.tableData.splice(i, 1)
            i--
          }
        }
        row.isEdit = true
      }
    },
    // 取消
    handleCancel(row, index) {
      row.isEdit = false
      if (!row.id) {
        this.tableData.splice(index, 1)
      }
    },
    // 删除
    handleDel(row) {
      console.log(row)
      const that = this
      var path = ''
      if (row.isMaster) {
        path = '/api/services/app/TeamMemberApply/DeleteTeamMemberApplyAndMember'
      } else {
        path = '/api/services/app/TeamMemberApply/DeleteTeamMemberApply'
      }
      this.$confirm('确定要删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$loading(KxjCom.loadOptions)
        pathReq.dataDelete(path, row.id).then(res => {
          this.$message.success('删除成功!')
          that.handleSearch()
        })
      })
        .catch(() => {
        })
    },
    /** 删除 */
    handleDel2(row) {
      console.log(row)
      const that = this
      var path = '/api/services/app/WorkEventMemberNewService/DeleteWorkEventMemberNew'
      this.$confirm('确定要删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$loading(KxjCom.loadOptions)
        pathReq.dataDelete(path, row.id).then(res => {
          this.$message.success('删除成功!')
          that.handleSearch()
        })
      })
        .catch(() => {
        })
    },
    // 新建或修改信息就是保存的时候
    handleSave(row) {
      if (!row.userName) {
        this.$message.error('请输入姓名')
        return false
      }

      const that = this
      var obj = { entityData: row }
      obj.entityData.moduleCode = this.moduleCode
      obj.entityData.moduleKey = this.moduleKey
      this.$loading(KxjCom.loadOptions)
      const path = '/api/services/app/TeamMemberApply/CreateOrUpdateTeamMemberApply'
      pathReq.postForm(path, obj).then(res => {
        if (res.status === 200) {
          if (res.data.success) {
            that.handleSearch()
          }
        }
      })
    },
    // 只能查看
    handleShowDetail(row, index) {
      console.log(row)
      console.log(index)
      alert('转到查看画面')
    },

    // 邀请成为会员
    handleAddBeUser(row) {
      console.log(row)
      alert('邀请成为会员')
    },
    /**
     * 显示课程信息
     */
    handleToDtl(id) {
      this.$router.push({
        name: 'contactdtl', params: { id: id }
      })
    },
    // 导入
    handleBeforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5
      if (isLt5M) {
        return true
      }
      this.$message.warning('数据超过5M')
      return false
    },
    handleImportSuccess({ results, header }) {
      const filterVal = [
        'userRoleDictItemName',
        'userName',
        'phoneNumber',
        'emailAddress',
        'sexDictItemName',
        'danWeiMingCheng',
        'danWeiBuMenFullName',
        'xueWeiDictIdItemName',
        'yanJiuLingYu',
        'yanJiuFangXiang'
      ]
      const data = KxjCom.formatJson(header, results)
      var b = []
      for (var i = 0; i < data.length; i++) {
        b.push(KxjCom.formatObj(filterVal, data[i]))
      }
      this.uploadData = b
      for (const row of this.uploadData) {
        row.moduleCode = this.moduleCode
        row.moduleKey = this.moduleKey
        row.sexDictKey = KxjCom.getComboxKeyByText(row.sexDictKey, this.getComboxData('D04'))
        row.xueWeiDictId = KxjCom.getComboxKeyByText(row.xueWeiDictId, this.getComboxData('D07'))
      }

      this.uploadFormShow = true
    },

    // 导出
    handleExport() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          '参与身份',
          '姓名',
          '手机号码',
          '电子邮箱',
          '性别',
          '单位名称',
          '部门/科研团队',
          '学位',
          '研究领域',
          '研究方向'
        ]
        const filterVal = [
          'userRoleDictItemName',
          'userName',
          'phoneNumber',
          'emailAddress',
          'sexDictItemName',
          'danWeiMingCheng',
          'danWeiBuMenFullName',
          'xueWeiDictIdItemName',
          'yanJiuLingYu',
          'yanJiuFangXiang'
        ]
        const list = this._data.tableData
        const data = KxjCom.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '成员列表', // 非必填
          autoWidth: true, // 非必填
          bookType: 'xlsx' // 非必填
        })
        this.downloadLoading = false
      })
    },
    /** 查看简历 */
    handleViewResume(row) {
      this.resumeUserId = row.userId
      this.resumeShow = true
    }

  }
}
</script>

<style scoped>
/* ffc059 */
</style>
